import { Suspense, startTransition } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import UpdateKRContainer from '../components/okr/update_kr/container';
import okrUpdateReducer from '../reducers/updateOKR.reducers';
import { KrUpdateModalManager } from '@workboard/ui-okr';
import { KrUpdateProvider } from './krUpdateValidationProvider';

// start of metric Update Key Results
const updateKRPageLoadComponent = function (props) {
	if(props != undefined) {
		setTimeout(() => {
			const updateOKRStore = createStore(okrUpdateReducer, props, applyMiddleware(thunkMiddleware));
			
			const uploadFile = (file) => window.FUS.uploadFile(file)

			startTransition(() => {
				ReactDOM.render(
					<Suspense fallback={null}>
						<Provider store={updateOKRStore}>
							<KrUpdateModalManager
								mixpanelLocation="UPDATES_NEEDED"
								mixpanelLocationDetail={location.pathname}
								uploadFile={uploadFile}
							>
								<KrUpdateProvider>
									<UpdateKRContainer goalsData={props} />
								</KrUpdateProvider>
							</KrUpdateModalManager>
						</Provider>
					</Suspense>,
					document.getElementById('updateKRWrapper'),
				)
			})
		})
	}
}

window.updateKRPageLoadComponent = updateKRPageLoadComponent;